// this is a special LD user representing a "public/any/all" user.
export const LD_ALL_USERS_CONTEXT = {
  kind: 'user',
  key: '-1',
  name: 'all users',
};
